import React, { Component } from "react";
import PropTypes from "prop-types";

const VolunteerSessionContext = React.createContext();

class VolunteerSessionProvider extends Component {
  static propTypes = {
    fetchSessionsByContactId: PropTypes.func.isRequired,
    children: PropTypes.any,
  };

  idsFetchedOrInFlight = new Set();
  is_mounted = false;

  componentDidMount() {
    this.is_mounted = true;
  }

  componentWillUnmount() {
    this.is_mounted = false;
  }

  fetchSessionsIfNotCached = contactId => {
    if (this.idsFetchedOrInFlight.size > 200) {
      this.idsFetchedOrInFlight = new Set();
    }
    const is_new_id = !this.idsFetchedOrInFlight.has(contactId);
    if (is_new_id) {
      this.fetchSessions(contactId);
    }
  };

  fetchSessions = contactId => {
    this.idsFetchedOrInFlight.add(contactId);
    this.toggleLoading(contactId, true);

    this.props
      .fetchSessionsByContactId({ contactId })
      .then(({ items = [] } = {}) => {
        if (this.is_mounted) {
          this.setState(
            prevState => ({ sessions: { ...prevState.sessions, [contactId]: items[0] } }),
            () => {
              this.toggleLoading(contactId, false);
            }
          );
        }
      })
      .catch(() => {
        this.toggleLoading(contactId, false);
      });
  };

  toggleLoading = (contactId, bool) => {
    if (this.is_mounted) {
      this.setState(prevState => ({ idsLoading: { ...prevState.idsLoading, [contactId]: bool } }));
    }
  };

  state = { sessions: {}, fetchSessionsIfNotCached: this.fetchSessionsIfNotCached, idsLoading: {} };

  render() {
    return (
      <VolunteerSessionContext.Provider value={this.state}>{this.props.children}</VolunteerSessionContext.Provider>
    );
  }
}

const useVolunteerSessionResolver = contactId => {
  const { sessions, idsLoading, fetchSessionsIfNotCached } = React.useContext(VolunteerSessionContext);

  React.useEffect(
    () => {
      fetchSessionsIfNotCached(contactId);
    },
    [contactId, fetchSessionsIfNotCached]
  );

  return {
    session: sessions[contactId] || {},
    loading: idsLoading[contactId],
  };
};

const VolunteerSessionResolver = props => {
  const { session, loading } = useVolunteerSessionResolver(props.contactId);
  return props.children({ session, loading });
};

VolunteerSessionProvider.propTypes = {};

export { useVolunteerSessionResolver, VolunteerSessionContext, VolunteerSessionProvider, VolunteerSessionResolver };
export default VolunteerSessionProvider;
